<template>
<div class="box-labourParticulars">
    <div class="nav">
        <img src="../../assets/up.png" alt="" class="upClass" @click="getOnPage1">
        费控系统
        <img src="../../assets/search.png" alt="" class="searchClass" @click="getOnPage">
    </div>

    <div class="swiper-container">
        <div class="swiper-wrapper">
            <div class="swiper-slide">
                <div class="labourParticulars">
                    <h4 class="labourParticulars-title labourParticulars-title-active">事后费用报销操作流程</h4>
                    <p class="labourParticulars-title-content-active-box" id="textTitleContent">第一步：登录OA系统（oa.xdf.cn，账户密码与个人企业邮箱同步），点击【费用审批】-【事后费用报销】-【我新建的费用报销】-【新建】，按照实际发生的费用类型选择【费用类别】建立表单。</p>
                    <p class="labourParticulars-title-content-active-box" id="textTitleContent">第二步：选择并完善标星处信息，点击【下拉箭头】，关联之前的费用申请或采购申请（只可关联一个）。选择关联【采购申请】时，若该【采购申请单】关联了【费用申请单】，则系统自动带出的【费用申请单】供参考；若关联的表单中，有借款业务且尚还款未清，系统将自动添加一条记录在【冲销】里，申请人也可根据实际情况取消【冲销】。</p>
                    <img src="../../assets/xiaNoPage.png" alt="" class="labourParticulars_bottomImg">
                </div>
            </div>
            <div class="swiper-slide">
                <div class="labourParticulars">
                    <h4 class="labourParticulars-title labourParticulars-title-active">事后费用报销操作流程</h4>
                    <p class="labourParticulars-title-content-active-box" id="textTitleContent">第三步：选择【业务明细】，如该笔款项涉及几个部门分摊，可点击【+】进行拆解。确认无误后，点击【确认业务明细填写完毕】。</p>
                    <p class="labourParticulars-title-content-active-box" id="textTitleContent">第四步：若【报销总金额】扣除【冲销借款单金额】和【实际支付金额】后不等于0，则差额部分金额自动计入【挂账应付款】中。</p>
                    <p class="labourParticulars-title-content-active-box" id="textTitleContent">第五步：当表单显示超出预算时，表示超出当季预算，即截止到报销日为止的预算额度，需填写【预算外支出说明】后，方可提交表单。</p>
                    <img src="../../assets/xiaNoPage.png" alt="" class="labourParticulars_bottomImg">
                </div>
            </div>
             <div class="swiper-slide">
                <div class="labourParticulars">
                    <h4 class="labourParticulars-title labourParticulars-title-active">事后费用报销操作流程</h4>
                    <p class="labourParticulars-title-content-active-box" id="textTitleContent">第六步：点击【事后费用报销】-【费用报销】-【所有报销单】，可在业务列表中查看单据状态、凭证号、当前处理人等信息，当审核节点为主管会计的时候，报销人需持报销单及原始票据到财务部进行现场审核。</p>
                    <img src="../../assets/6.jpeg" alt="" class="QRcode">
                    <sup id="box_text_content">长按观看视频教程</sup>
                </div>
            </div>
        </div>
    </div>

</div>
</template>

<script>
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
export default {
    data() {
        return {
            fingerprintShow: false,
            flowShow: false,
            agreementShow: false
        };
    },
    methods: {
        getOnPage1(){
            var name = this.$route.params.name
            if(name == 'io'){
                this.$router.push({name:"IssueManpower1"})
            }else {
                this.$router.push({name:"Finance"})
            }
        },
        fn() {
            var code = this.$route.params.code;
            if (code == 11) {
                this.fingerprintShow = true;
            } else if (code == 12) {
                this.flowShow = true;
            } else if (code == 79) {
                this.agreementShow = true;
            }
        },
        getOnPage(){
            this.$router.push({name: 'Search', params:{code:"111"}})
        },
    },
    mounted() {
        this.fn();
        var mySwiper = new Swiper(".swiper-container", {
            direction: "vertical" // 垂直切换选项
            // loop: true // 循环模式选项
        });
    }
};
</script>

<style>
.swiper-container {
    width: 100%;
    height: 100%;
}

.box-labourParticulars {
    width: 100%;
    height: 100%;
    background: rgba(244, 244, 244, 1);
    overflow: hidden;
}

.nav {
    width: 100%;
    height: 50px;
    background: #11a093;
    text-align: center;
    line-height: 50px;
    color: #ffffff;
    position: relative;
    margin-bottom: 17px;
}

.upClass,
.searchClass {
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
}

.upClass {
    width: 12px;
    float: left;
    left: 10px;
}

.searchClass {
    width: 19px;
    float: right;
    right: 10px;
}

.labourParticulars {
    width: 90%;
    height: 83%;
    margin: 0 auto;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 12px 0px rgba(136, 135, 135, 0.5);
    border-radius: 11px;
    padding-top: 5%;
    position: relative;
}

.labourParticulars .labourParticulars-title {
    text-align: center;
    font-weight: 600;
}

.labourParticulars .labourParticulars-hw {
    margin-bottom: 20px;
}

.labourParticulars p {
    color: #696969;
    font-size: 16px;
    margin: 20px 16px 0;
}

.labourParticulars span {
    display: block;
    line-height: 30px;
    margin-left: 16px;
    margin-right: 16px;
    color: #888787;
    font-size: 14px;
}

.labourParticulars .spanClass {
    text-indent: 30px;
}

.labourParticulars_bottomImg {
    width: 15%;
    display: block;
    left: 0;
    right: 0;
    margin: auto;
    position: absolute;
    bottom: 12px;
}

.QRcode {
    width: 30% !important;
    display: block;
    margin: 10px auto;
}

.labourParticulars-title-active {
    font-size: 16px
}
.labourParticulars-title-content-active-box {
    letter-spacing:2px;
    line-height: 25px;
    font-size: 14px
}
#textTitleContent {
    color: #888787;
    font-size: 14px;
}
#box_text_content {
    width: 100%;
    display: block;
    font-size: 12px;
    color: #ccc;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Finance/finance4.vue